"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarouselItem = exports.Frame = void 0;
const app_1 = require("@obvio/app");
exports.Frame = app_1.styled.div `
  position: relative;
  flex: 1;
  overflow: hidden;
`;
exports.CarouselItem = app_1.styled.div `
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  > * {
    max-width: 100%;
    max-height: 100%;
  }
`;
